import {  TableRow, TableHead  } from "@mui/material";
import TableCell from './TableCell';

import { SortObj, TableHeader } from 'edocatbase/Table';

export interface TableHeadProps {
  tableName: string;
  tableHeaders: TableHeader[];
  sortObj: SortObj;
  tableSortHandler?: (id: string, direction: 'asc' | 'desc') => void;
  showSort: boolean;
}

export default class EdocatTableHead extends React.PureComponent<TableHeadProps> {
  render() {
    const { tableHeaders, sortObj, tableSortHandler, tableName, showSort } = this.props;

    return (
      <TableHead>
        <TableRow>
          {tableHeaders.map((header, index) => (
            <TableCell
              key={index}
              tableName={tableName}
              sortObj={sortObj}
              header={header}
              tableSortHandler={tableSortHandler}
              showSort={showSort}
            />
          ))}
        </TableRow>
      </TableHead>
    );
  }
}
